import { useEffect } from "react";

export default function useVideoPositioning({
  mainVideoContainerRef,
  activeIndex,
  contentsLength,
  isMobile,
}) {
  // Позиционирование главного video над активным элементом
  useEffect(() => {
    if (!mainVideoContainerRef.current || contentsLength === 0) {
      return;
    }

    // Небольшая задержка для того, чтобы элементы успели отрендериться
    const positionVideo = () => {
      const container = mainVideoContainerRef.current;
      const feedContainer = document.querySelector("[data-shorty-feed]");

      console.log("🎬 useVideoPositioning triggered", {
        activeIndex,
        contentsLength,
        isMobile,
        hasContainer: !!container,
        hasFeedContainer: !!feedContainer,
      });

      if (!container || !feedContainer) {
        console.log("❌ useVideoPositioning: Missing containers");
        return;
      }

      // Рассчитываем позицию математически, не полагаясь на существование DOM элементов
      // Это решает проблему с виртуализацией, когда элементы могут не существовать в DOM
      const elementHeight = isMobile
        ? window.innerHeight
        : window.innerHeight - 64;

      const targetTop = activeIndex * elementHeight;

      console.log("📐 useVideoPositioning calculation:", {
        activeIndex,
        elementHeight,
        targetTop,
        windowHeight: window.innerHeight,
      });

      // Позиционируем главное видео на весь контейнер
      container.style.display = "block";
      container.style.top = `${targetTop}px`;
      container.style.height = isMobile ? "100dvh" : "calc(100vh - 64px)";

      if (isMobile) {
        // На мобилах видео на весь экран по ширине
        container.style.width = "100%";
        container.style.left = "0px";
      } else {
        // На десктопе фиксируем высоту и рассчитываем ширину с сохранением пропорций 9:16
        const desiredWidth = Math.min(
          window.innerWidth,
          Math.round((elementHeight * 9) / 16)
        );
        const left = Math.max(
          0,
          Math.round((window.innerWidth - desiredWidth) / 2)
        );

        container.style.width = `${desiredWidth}px`;
        container.style.left = `${left}px`;
      }

      console.log(
        "✅ useVideoPositioning: Video positioned at top:",
        targetTop
      );
    };

    // Выполняем позиционирование с небольшой задержкой
    const timeoutId = setTimeout(positionVideo, 50);

    return () => clearTimeout(timeoutId);
  }, [activeIndex, contentsLength, isMobile, mainVideoContainerRef]);
}
